module.exports = __webpack_public_path__ + "img/banner02.97e3ba7a.jpg";